
// TODO probs could use a lib
// from http://stackoverflow.com/q/13720256
export function camelCaseToLowerCase(s: string): string {
  return s.replace(/^[a-z]|[A-Z]/g, function (v, i) {
    return i === 0 ? v.toLowerCase() : " " + v.toLowerCase();
  });
}

// Based on https://stackoverflow.com/a/23619085/2685551
export function elementsToSentence(elements: (JSX.Element | string)[], join: string = "and"): (JSX.Element | string)[] {
  if (elements == null || elements.length === 0) {
    return [];
  }

  let [first, ...rest] = elements;

  return rest.reduce((els, next, index) => {
    let sep = index < elements.length - 2 ? ", " : ` ${join} `; // No Oxford comma
    return els.concat([sep, next]);
  }, [first]);
}

export function arrayToSentence(arr: string[], join: string = "and", oxford: boolean = true): string {
  if (!arr || arr.length < 1) {
    return "";
  }
  else if (arr.length == 1) {
    return arr[0];
  }
  else {
    const last = arr[arr.length - 1];
    const arrClone = arr.slice(0, arr.length - 1);
    return `${arrClone.join(", ")}${oxford && arrClone.length > 1 ? "," : ""} ${join} ${last}`;
  }
}

export function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/**
 * Turn multiline strings into single line strings
 */
export function stripNewLines(str: string): string {
  if (!str) {
    return str;
  }

  return str.split(/\r?\n/).map(piece => piece.trim()).join(" ");
}


/** Translate HTML &amp; entities into the symbols
 * https://stackoverflow.com/a/46851765/268555
 */
export function unescapeHtml(html: string): string {
  var el = document.createElement('div');
  return html.replace(/\&[#0-9a-z]+;/gi, enc => {
    el.innerHTML = enc;
    return el.innerText;
  });
}
